import { API_GET_LIST_CLIENT_NEGOTIATE_SUCCESS } from '@/actions/ClientRfpNegotiateActions/getList';
const initialState = {
    one: {},
};
export const clientRfpNegotiateList = (state = initialState, result) => {
    const { meta, payload, type } = result;
    switch (type) {
        case API_GET_LIST_CLIENT_NEGOTIATE_SUCCESS: {
            const { id = '' } = meta.requestPayload;
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), { [id]: payload }) });
        }
        default: {
            return state;
        }
    }
};
